import { Integration } from './Integration';
import type { IntegrationsData } from './Integrations';

interface IntegrationGridProps {
  integrations: IntegrationsData[number]['items'];
}

export const IntegrationGrid = ({
  integrations,
}: IntegrationGridProps): JSX.Element => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
      {integrations.map(
        ({
          title,
          description,
          logoUrl,
          connected,
          available,
          to,
          onClick,
          pending,
          warnings,
          donePercentage,
          scanProgress,
          isSyncing,
        }) => (
          <Integration
            logoUrl={logoUrl}
            connected={connected}
            available={available}
            title={title}
            description={description}
            onClick={onClick}
            to={to}
            key={title}
            pending={pending}
            warnings={warnings}
            donePercentage={donePercentage}
            scanProgress={scanProgress}
            isSyncing={isSyncing}
          />
        ),
      )}
    </div>
  );
};
